import { forwardRef } from "react";
import type { ElementRef } from "react";
import * as TogglePrimitive from "@radix-ui/react-toggle";
import { cx, cva } from "class-variance-authority";
import type { VariantProps } from "class-variance-authority";
import * as styles from "./Pill.module.scss";

const toggleVariants = cva(styles.pillBase, {
  variants: {
    variant: {
      default: styles.pill,
      button: styles.button,
    },
    size: {
      small: styles.small,
      default: styles.medium,
      large: styles.large,
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});

type PillProps = React.ComponentPropsWithoutRef<typeof TogglePrimitive.Root> &
  VariantProps<typeof toggleVariants> & {
    overrideSvgFill?: boolean;
  };

const Pill = forwardRef<ElementRef<typeof TogglePrimitive.Root>, PillProps>(
  (
    { className, variant, size, disabled, overrideSvgFill = true, ...props },
    ref,
  ) => (
    <TogglePrimitive.Root
      ref={ref}
      disabled={disabled}
      className={cx(toggleVariants({ variant, size }), className, {
        [styles.disabled]: disabled,
        [styles.overrideSvgFill]: overrideSvgFill,
      })}
      {...props}
    />
  ),
);

Pill.displayName = "Pill";

export { Pill };
